module.exports = __webpack_public_path__ + "img/chart_white.c22bbd50.svg";